module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.tabClasses
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.position !== 'bottom'),
      expression: "position !== 'bottom'"
    }],
    class: _vm.navPosition,
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('ul', {
    class: _vm.navClasses
  }, [_vm._l((_vm.tabPanes), function(tabPane, index) {
    return (_vm.limit > index) ? _c('li', {
      key: index,
      class: {
        active: tabPane.active
      }
    }, [_c('a', {
      attrs: {
        "href": "javscript:;"
      },
      on: {
        "click": function($event) {
          _vm.setActive(tabPane)
        }
      }
    }, [(tabPane.icon) ? _c('i', {
      class: 'fa fa-' + tabPane.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(tabPane.name) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.limit > 0 && _vm.limit < _vm.tabPanes.length) ? _c('li', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (function () { return _vm.dropdownShow = false; }),
      expression: "() => dropdownShow = false"
    }],
    staticClass: "dropdown",
    class: {
      active: _vm.limit <= _vm.tabIndex
    },
    on: {
      "click": function($event) {
        _vm.dropdownShow = !_vm.dropdownShow
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownShow),
      expression: "dropdownShow"
    }],
    staticClass: "dropdown-menu pull-right",
    staticStyle: {
      "display": "block"
    }
  }, _vm._l((_vm.tabPanes), function(tabPane, index) {
    return (_vm.limit <= index) ? _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "javscript:;"
      },
      on: {
        "click": function($event) {
          _vm.setActive(tabPane)
        }
      }
    }, [(tabPane.icon) ? _c('i', {
      class: 'fa fa-' + tabPane.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(tabPane.name) + "\n            ")])]) : _vm._e()
  }))]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    class: _vm.panePosition
  }, [_c('div', {
    class: _vm.paneClasses
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.position === 'bottom'),
      expression: "position === 'bottom'"
    }],
    class: _vm.navPosition,
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('ul', {
    class: _vm.navClasses
  }, [_vm._l((_vm.tabPanes), function(tabPane, index) {
    return (_vm.limit > index) ? _c('li', {
      key: index,
      class: {
        active: tabPane.active
      }
    }, [_c('a', {
      attrs: {
        "href": "javscript:;"
      },
      on: {
        "click": function($event) {
          _vm.setActive(tabPane)
        }
      }
    }, [(tabPane.icon) ? _c('i', {
      class: 'fa fa-' + tabPane.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(tabPane.name) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.limit > 0 && _vm.limit < _vm.tabPanes.length) ? _c('li', {
    staticClass: "dropdown",
    class: {
      active: _vm.limit <= _vm.tabIndex
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right",
    staticStyle: {
      "display": "block"
    }
  }, _vm._l((_vm.tabPanes), function(tabPane, index) {
    return (_vm.limit <= index) ? _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "javscript:;"
      },
      on: {
        "click": function($event) {
          _vm.setActive(tabPane)
        }
      }
    }, [(tabPane.icon) ? _c('i', {
      class: 'fa fa-' + tabPane.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(tabPane.name) + "\n            ")])]) : _vm._e()
  }))]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(" 更多\n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(" 更多\n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af1712c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/tabs.vue
// module id = 551
// module chunks = 84